import React, { useState, useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate, useSearchParams } from 'react-router-dom'

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { verifyEmail } = useAuth()

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  const token = searchParams.get('token')

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setError('Invalid or missing verification token')
        setLoading(false)
        return
      }

      try {
        await verifyEmail(token)
        setSuccess(true)
        setTimeout(() => {
          navigate('/')
        }, 3000)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Email verification failed')
      } finally {
        setLoading(false)
      }
    }

    verify()
  }, [token, verifyEmail, navigate])

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4 pt-32 pb-12">
        <div className="w-full max-w-md bg-[#141414] rounded-lg shadow-xl border border-white/10 p-8">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 mb-4">
              <svg className="animate-spin h-8 w-8 text-rose-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">Verifying Email...</h2>
            <p className="text-neutral-400">
              Please wait while we verify your email address.
            </p>
          </div>
        </div>
      </div>
    )
  }

  if (success) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4 pt-32 pb-12">
        <div className="w-full max-w-md bg-[#141414] rounded-lg shadow-xl border border-white/10 p-8">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
              <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">Email Verified!</h2>
            <p className="text-neutral-400 mb-6">
              Your email has been successfully verified. Redirecting to home page...
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4 pt-32 pb-12">
      <div className="w-full max-w-md bg-[#141414] rounded-lg shadow-xl border border-white/10 p-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
            <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Verification Failed</h2>
          <p className="text-neutral-400 mb-6">
            {error}
          </p>
          <button
            onClick={() => navigate('/')}
            className="w-full py-3 px-4 bg-rose-600 hover:bg-rose-700 text-white font-medium rounded-xl transition-colors"
            style={{ boxShadow: '0 2px 8px rgba(225, 29, 72, 0.25)' }}
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  )
}

export default VerifyEmail
